import MapView from 'esri/views/MapView';
import EsriMap from 'esri/Map';
import SketchViewModel from 'esri/widgets/Sketch/SketchViewModel';

export type View = MapView;
export type Map = EsriMap;
export type SketchView = SketchViewModel;

export type BaseMapItem = {
  thumbnailUrl: string;
  id: string;
  title: string;
  theme: 'light' | 'dark';
  fromPortal: boolean;
};

export type BaseMapOptions = BaseMapItem[];

export interface MapModules {
  Map: __esri.Map;
  MapView: __esri.MapView;
  Extent: __esri.Extent;
  GeometryEngine: __esri.geometryEngine;
  SpatialReference: __esri.SpatialReference;
  WebMercatorUtils: __esri.webMercatorUtils;
  Graphic: __esri.Graphic;
  GraphicsLayer: __esri.GraphicsLayer;
  SketchViewModel: __esri.SketchViewModel;
  FeatureLayer: __esri.FeatureLayer;
  Config: __esri.Config;
  PortalItem: __esri.PortalItem;
  IdentityManager: __esri.IdentityManager;
}

export interface Shape {
  type: string;
  coordinates: [];
  bbox?: [];
}

export interface MapPlaceSuggestionCustomFields {
  locality: string;
  region: string;
}

export interface GeocodeCoordinatePayload {
  datasets: string;
  latitude: string;
  longitude: string;
}

export interface GeocodeType {
  formattedaddress: string;
  locality: string;
  postcode: string;
  region: string;
}

export enum MAP_DATA_SERVICE_DATA_SET {
  GEOCODEAU = 'geocodeau',
  GNAF = 'gnaf',
  GNAF_ADDRESS = 'gnaf_address',
  GNAFLPID = 'gnaflpid'
}

export enum MAP_DEFAULT_VAR {
  BASEMAP = '2ce6cd133d1c41a3afdd44c0d0c4f2a9'
}

export interface MapDrawFuncParams {
  tool: string;
  graphic: any;
  graphics: any[] | undefined;
  drawingLayer: __esri.GraphicsLayer;
  userReference?: any;
}

interface stateAcronymModel {
  [key: string]: string;
}

export const stateAcronym: stateAcronymModel = {
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Northern Territory': 'NT',
  Queensland: 'QLD',
  'South Australia': 'SA',
  Victoria: 'VIC',
  Tasmania: 'TAS',
  'Western Australia': 'WA'
};

export type BaseMap =
  | string
  | {
      portalItem: {
        id: string;
      };
    };
